module.exports = __webpack_public_path__ + "static/media/Tackling_2.23c7a0ff.png";